<template>
  <div class="input-with-button-widget">
    <input
      :type="type"
      :disabled="disabled"
      :value="value"
      :placeholder="placeholder"
      class="widget_input"
      @change="onChange"
      @blur="onBlur"
      @focus="onFocus"
      @keyup="onKeyup"
      @keydown="onKeydown"
      @click="onClick"
    />
    <button class="btn btn-submit" @click="submitValue()">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  name: "input-with-button-widget",
  props: {
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      input_value: "",
    };
  },
  watch: {},
  mounted() {},
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("change", e);
    },
    onBlur(e) {
      let vm = this;
      vm.$emit("blur", e);
    },
    onFocus(e) {
      let vm = this;
      vm.$emit("focus", e);
    },
    onKeyup(e) {
      let vm = this;
      vm.input_value = e.target.value;
    },
    onKeydown(e) {
      let vm = this;
      vm.input_value = e.target.value;
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
    submitValue() {
      let vm = this;
      vm.$emit("submit", vm.input_value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.input-with-button-widget {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #c3cad9;
  border-radius: 5px;
  .widget_input {
    height: 40px;
    border-radius: 5px;
    font-weight: 500;
    width: 100%;
    position: relative;
    background: #fff;
    outline: none;
    border: none;
    padding: 0px 10px;
  }
  .btn {
    height: 42px;
    min-width: 42px;
    padding: 0px 10px;
    background: #f8f9fa;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
